// store.ts
import { configureStore } from "@reduxjs/toolkit";
import modalReducer, { modalSlice } from "./slice/modalSlice";
import toggleReducer, { toggleSlice } from "./slice/toggleSlice";
import tradingPlayersReducer, { tradingPlayersSlice } from "./slice/tradingPlayersSlice";
import _ from "lodash";

const store = configureStore({
  reducer: {
    modal: modalReducer,
    toggle: toggleReducer,
    tradingPlayers: tradingPlayersReducer,
  },
});

const createActions = (slice: any) =>
  _.mapValues(
    slice.actions,
    (actionCreator) => (payload: any) => store.dispatch(actionCreator(payload)),
  );

export const actions = {
  modal: createActions(modalSlice),
  toggle: createActions(toggleSlice),
  tradingPlayers: createActions(tradingPlayersSlice),
};

export default store;
